import { ClockIcon } from "@phosphor-icons/react";
import dayjs from "apps/visits/packages/shared/libs/dayjs";
import { DATE_FORMAT, TIME_FORMAT } from "../../config/date-time";

type TimeSlotInfoProps = {
  timeSlot: dayjs.Dayjs;
};

export const TimeSlotInfo = ({ timeSlot }: TimeSlotInfoProps) => {
  const isValidTimeSlot = dayjs(timeSlot).isValid();
  return (
    <div className="flex items-center gap-x-4">
      <span className="font-medium">{isValidTimeSlot ? timeSlot.format(DATE_FORMAT) : "-"}</span>
      <span className="flex items-center gap-x-2 text-muted-foreground">
        <ClockIcon className="size-4" />
        {isValidTimeSlot ? timeSlot.format(TIME_FORMAT) : "-"}
      </span>
    </div>
  );
};
